import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMortgageMiniCalculatorMicrofrontend } from 'shared/hooks/useMortgageMiniCalculatorMicrofrontend';
import { selectIsScrollToCalculator } from 'shared/selectors';
import { selectMortgageMiniCalculatorEnabled } from 'shared/selectors/featureToggle';

export const NewbuildingMortgageCalculatorMicrofrontend: React.FC = () => {
  const isNewMortgageCalculatorMicrofrontendEnabled = useSelector(selectMortgageMiniCalculatorEnabled);
  const { isAvailable, manifest } = useMortgageMiniCalculatorMicrofrontend(isNewMortgageCalculatorMicrofrontendEnabled);

  const isScrollToCalculator = useSelector(selectIsScrollToCalculator);

  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isScrollToCalculator && containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }, [isScrollToCalculator]);

  if (!isAvailable) {
    return null;
  }

  return (
    <div ref={containerRef}>
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        instance={manifest.instanceId}
      />
    </div>
  );
};
